__turbopack_context__.v({
  "blinkGreen": "PresaleProgress-module__tRxWEW__blinkGreen",
  "buttonGlow": "PresaleProgress-module__tRxWEW__buttonGlow",
  "buyButton": "PresaleProgress-module__tRxWEW__buyButton",
  "countdownContainer": "PresaleProgress-module__tRxWEW__countdownContainer",
  "countdownHeader": "PresaleProgress-module__tRxWEW__countdownHeader",
  "countdownLabel": "PresaleProgress-module__tRxWEW__countdownLabel",
  "countdownSeparator": "PresaleProgress-module__tRxWEW__countdownSeparator",
  "countdownTimer": "PresaleProgress-module__tRxWEW__countdownTimer",
  "countdownUnit": "PresaleProgress-module__tRxWEW__countdownUnit",
  "countdownValue": "PresaleProgress-module__tRxWEW__countdownValue",
  "cta": "PresaleProgress-module__tRxWEW__cta",
  "errorMessage": "PresaleProgress-module__tRxWEW__errorMessage",
  "fadeInOutGreen": "PresaleProgress-module__tRxWEW__fadeInOutGreen",
  "figures": "PresaleProgress-module__tRxWEW__figures",
  "finalDay": "PresaleProgress-module__tRxWEW__finalDay",
  "header": "PresaleProgress-module__tRxWEW__header",
  "infoItem": "PresaleProgress-module__tRxWEW__infoItem",
  "label": "PresaleProgress-module__tRxWEW__label",
  "loading": "PresaleProgress-module__tRxWEW__loading",
  "loadingMessage": "PresaleProgress-module__tRxWEW__loadingMessage",
  "percentComplete": "PresaleProgress-module__tRxWEW__percentComplete",
  "presaleContainer": "PresaleProgress-module__tRxWEW__presaleContainer",
  "progressBackground": "PresaleProgress-module__tRxWEW__progressBackground",
  "progressBar": "PresaleProgress-module__tRxWEW__progressBar",
  "progressMarker": "PresaleProgress-module__tRxWEW__progressMarker",
  "progressWrapper": "PresaleProgress-module__tRxWEW__progressWrapper",
  "pulse": "PresaleProgress-module__tRxWEW__pulse",
  "pulseGreen": "PresaleProgress-module__tRxWEW__pulseGreen",
  "pulseGreenBorder": "PresaleProgress-module__tRxWEW__pulseGreenBorder",
  "raised": "PresaleProgress-module__tRxWEW__raised",
  "salesBreakdown": "PresaleProgress-module__tRxWEW__salesBreakdown",
  "shakeGreen": "PresaleProgress-module__tRxWEW__shakeGreen",
  "target": "PresaleProgress-module__tRxWEW__target",
  "timerIcon": "PresaleProgress-module__tRxWEW__timerIcon",
  "tokenInfo": "PresaleProgress-module__tRxWEW__tokenInfo",
  "totalIncludesNote": "PresaleProgress-module__tRxWEW__totalIncludesNote",
  "urgencyMessage": "PresaleProgress-module__tRxWEW__urgencyMessage",
  "value": "PresaleProgress-module__tRxWEW__value",
});
